<div role="dialog" aria-live="polite" aria-label="cookieconsent" aria-describedby="cookieconsent:desc"
  class="cc-window cc-floating cc-bottom cc-right" id="chatDiv">

  <div class="container boxShadow">
    <div class="p-3 adiv text-white" (click)="minimizeChat();">
      <!-- <i class="fas fa-chevron-left"></i> -->
      <span>Shareholder's chat</span> <span class="float-right">
        <!-- <i class="far fa-minus-square" (click)="minimizeChat();"></i>
        <i class="ml-2 fas fa-times" (click)="closeChat();"></i> -->
        <i class="ml-2 fas fa-times"></i>
      </span>
    </div>
    <div class="card float-right">
      <div class="chatScroll" id='scrollMe' #scrollMe>
        <div *ngFor="let chat of chatData;let i = index;">
          <div class="leftSide" *ngIf="chat?.message">
            <div>
              <!-- <img src="../../../../assets/images/business_user.svg" width="30"
                height="30"> -->
              {{chat?.name}}
            </div>
            <div class="chat ml-2 messageBody">{{chat?.message}}</div>
            <p class="ml-2 small text-muted">{{chat?.enquiryOn | date:'MMMM d, y hh:mm:ss'}}</p>
          </div>
          <div class="rightSide d-flex align-items-end flex-column" *ngIf="chat?.reply">
            <div>
              <!-- {{this.user.firstName}} -->
              You
              <!-- <img src="../../../../assets/images/female_business_user.svg" width="30"
                height="30"> -->
            </div>
            <div class="bgColors mr-2 messageBody" *ngIf="this.editData[i]?.editable == false"
              (click)="editData[i].editable=true;">{{chat?.reply}}</div>

            <div *ngIf="editData[i].editable">
              <textarea class="form-control chatWidth" placeholder="Type your message" maxlength="1000"
                [(ngModel)]="editData[i].reply"></textarea>

              <button id="button-reply" type="button" class="btn btn-link float-right"
                (click)="sendReply(editData[i].reply,editData[i].enquiryId)"> <i class="fa fa-paper-plane"></i></button>
            </div>

            <p class="small text-muted" *ngIf="!editData[i].editable">
              {{chat?.lastUpdateOn | date:'MMMM d, y  hh:mm:ss'}}</p>
          </div>

        </div>
      </div>

      <!-- <div class="form-group"> -->
      <div class="sendArea">
        <textarea class="form-control col-md-11" rows="4" placeholder="Type your message" maxlength="1000"
          [(ngModel)]="replyMsg" #mainText></textarea>
        <button id="button-addon2" type="submit" class="btn btn-link col-md-auto" appDebounceClick
          (debounceClick)="sendReply(this.replyMsg)"><i class="fa fa-paper-plane"></i></button>
      </div>
      <!-- </div> -->

      <!-- Typing area -->
      <!-- <form action="#" class="bg-light">
        <div class="input-group">
          <input type="text" placeholder="Type a message" aria-describedby="button-addon2" class="form-control rounded-0 border-0 py-4 bg-light">
          <div class="input-group-append">
            <button id="button-addon2" type="submit" class="btn btn-link"> <i class="fa fa-paper-plane"></i></button>
          </div>
        </div>
      </form> -->
    </div>
  </div>

</div>

<div class="miniChat" *ngIf="this.minimize===true" (click)="openFullChat()">
  <div class="d-flex align-items-center justify-content-center">
    <i class="far fa-2x fa-comment-alt"></i>
  </div>
</div>
